export const Types = {
  LARGE: "large",
  SMALL: "small",
};

export const Status = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};
